
import Layout from '../../../layouts/main'
import { useState } from 'react';
import { toast } from 'react-toastify';
import config from '../../../../configuration/config.json'
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import cbor from 'borc';
import { Buffer } from 'buffer';
import { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal'
import QRCode from 'react-qr-code';
import cameraicon from "../../../../images/hid-icons_030-CAMERA.svg";
import clearicon from "../../../../images/hid-icons_095-CLEAR.svg";
import uploadicon from "../../../../images/hid-icons_186-UPLOAD.svg";
import { Base64 } from 'js-base64';


export default () => {
    let { id } = useParams();
    let isUpdateMode = id != undefined ? true : false;

    const navigate = useNavigate();
    const [getdocuments, setdocuments] = useState([]);
    const [getSelectedDocId, setSelectedDocId] = useState('0');
    const [getTemplateMode, setTemplateMode] = useState('Exist');
    const [getSaveMode, setSaveMode] = useState('');
    const [getTemplateHeaders, setTemplateHeaders] = useState([]);
    const [getSelectedTemplateId, setSelectedTemplateId] = useState('0');
    const [getSelectedDocumentData, setSelectedDocumentData] = useState([]);
    const [smShow, setSmShow] = useState(false);
    const [value, setValue] = useState();
    const [back, setBack] = useState('#FFFFFF');
    const [fore, setFore] = useState('#000000');
    const [size, setSize] = useState(400);
    const [userstatevalue, setuserstatevalue] = useState(false);


    var issuerReference = '';
    var objectPix1HexModified = '';


    const onInputChange = (e) => {
        const { value } = e.target;

        const re = /^[A-Za-z0-9]+$/;
        if (value === "" || re.test(value)) {
            issuerReference = value.toUpperCase();
        }
        document.getElementById('tbIssuerReference').value = issuerReference;
    }

    const loadDataOnlyOnce = async () => {
        const response = await axios.request({
            method: 'GET',
            url: config.operatorportal.apibaseurl + 'document/configurations/schemas',
            headers: { "content-type": "application/cbor", Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
            responseType: 'arraybuffer',
            responseEncoding: 'binary'
        });

        if (response.status == 200) {
            let documentSchemasDecoded = cbor.decode(new Buffer(response.data));
            setdocuments(documentSchemasDecoded.documents);
        } else {
            setdocuments([]);
        }

    }

    const loadTemplateHeaders = async () => {
        const response = await axios.request({
            method: 'GET',
            url: config.operatorportal.apibaseurl + 'document/configurations/templates/headers',
            headers: { "content-type": "application/cbor", Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
            responseType: 'arraybuffer',
            responseEncoding: 'binary'
        });

        if (response.status == 200) {
            let templateHeadersDecoded = cbor.decode(new Buffer(response.data));
            setTemplateHeaders(templateHeadersDecoded);
        } else {
            setTemplateHeaders([]);
        }


    }


    const imgWidth = 200
    const imgHeight = 200

    const takePicture = (e) => {
        let video =
            document.getElementById(e.target.id.replace('take_', 'video_'));
        let photo =
            document.getElementById(e.target.id.replace('take_', 'canvas_'));

        navigator.mediaDevices
            .getUserMedia({
                video: true
            })
            .then((stream) => {
                video.srcObject = stream;
                video.play();
            })
            .catch((err) => {
                toast.error('Please enable camera and try again');
                return;
            });

        photo.width = imgWidth
        photo.height = imgHeight
        let ctx = photo.getContext('2d')
        ctx.drawImage(video, 0, 0, imgWidth, imgHeight)
        video.hidden = true;
        photo.hidden = false;
    }

    const clearImage = (e) => {

        let video =
            document.getElementById(e.target.id.replace('clearphoto_', 'video_'));
        let photo =
            document.getElementById(e.target.id.replace('clearphoto_', 'canvas_'));

        let ctx = photo.getContext('2d')
        ctx.clearRect(0, 0, imgWidth, imgHeight)
        video.hidden = false;
        photo.hidden = true;
    }


    function handleChange(e) {

        if (e.target.files && e.target.files[0]) {
            let video =
                document.getElementById(e.target.id.replace('file_', 'video_'));
            let photo =
                document.getElementById(e.target.id.replace('file_', 'canvas_'));
            let ctx = photo.getContext('2d')
            ctx.clearRect(0, 0, photo.width, photo.height);
            ctx.beginPath();
            var FR = new FileReader();
            FR.onload = function (e) {
                var img = new Image();
                img.src = e.target.result;
                img.onload = function () {
                    photo.width = this.naturalWidth;
                    photo.height = this.naturalHeight;
                    ctx.drawImage(img, 0, 0);
                };
            };
            FR.readAsDataURL(e.target.files[0]);
            video.hidden = true;
            photo.hidden = false;
        }

    }

    useEffect(() => {

        loadDataOnlyOnce();
        loadTemplateHeaders();
    }, [])

    return (
        <Layout>

            <div class="container-fluid mt-5">
                <div class='row'>
                    <h class='header1'>{id == undefined ? 'Enrollment' : 'Enrollment Update'}</h>
                </div>
                <div class="row">
                    <div class="col-md-6  mt-3">
                        {
                            (getTemplateMode == 'Exist') ?
                                <select class="textField" onChange={populateSelectedTemplateDetails} id='ddlTemplates'>
                                    <option value='0'>Select Enrollment Template</option>
                                    {
                                        getTemplateHeaders.map(header => (
                                            <option value={header._id}>{header.friendlyName}</option>
                                        ))
                                    }
                                </select>
                                :
                                <input type="text" id='tbTemplateName' class="textField" placeholder="Template Name" />
                        }

                    </div>
                    <div class="col-md-6">

                        {

                            (getSaveMode == 'Save' || getTemplateMode == 'New' || isUpdateMode) ?
                                <button type="button" class="secondaryButton mt-4 ms-1" onClick={CancelTemplateMode} aria-label="submit">Cancel</button> : ''

                        }

                        {

                            (getSaveMode == 'Save') ?
                                <button type="button" class="primaryButton mt-4 ms-1" onClick={postconfigurations} aria-label="submit">{isUpdateMode ? 'Update' : 'Submit'}</button>
                                : ''

                        }



                    </div>
                </div>

                <div class='row'>



                    <div style={{ display: getSelectedTemplateId != '0' ? 'block' : 'none' }}>
                        <div class="form-group  mt-3">
                            <input type='text' id={'tbIssuerReference'}
                                onChange={onInputChange} class="textField formText w-25"
                                disabled={isUpdateMode}
                                placeholder='Issuer Reference'

                            />
                        </div>

                    </div>
                </div>
                <div class='row'>
                    <div className='col'>
                        <div key={Math.random()}>

                            {
                                getSelectedDocumentData?.map(ds =>
                                (
                                    <>
                                        <div class='row'>

                                            <div class="col mt-3">
                                                <label className='docTypeHeader'>Doc Type:&nbsp;</label>
                                                <label className='docTypeHeader textTransformNone'>{ds.documentData.docType}</label>

                                            </div>
                                        </div>

                                        {

                                            ds.documentData.namespaces?.map(nm => (

                                                <div class='row'>

                                                    <div class="card mt-2 cardField">
                                                        <div class="card-body">

                                                            <div class="col mt-3">
                                                                <div class='row'>
                                                                    <div class='col header2 textTransformNone'>
                                                                        <h5>Namespace: {nm.name}</h5>
                                                                    </div>
                                                                </div>
                                                                <div class='row'>
                                                                    {nm.labels?.map(lb =>

                                                                    (
                                                                        lb.enrollment_flag != undefined && lb.enrollment_flag == true && lb.control_type == 'photo' ?
                                                                            <div class='col-4'>

                                                                                <div class="form-group  mt-3">
                                                                                    <label class='formText'>{lb.local_language_name == undefined || lb.local_language_name == '' ? lb.name
                                                                                        : lb.name + ' / ' + lb.local_language_name
                                                                                    }</label>

                                                                                    <div class='container'>
                                                                                        <div class='row mt-3'>
                                                                                            <div class='col'>
                                                                                                <video className="videoControl" id={'video_' + getSelectedDocId + '_' + nm.name + '_' + lb.name}></video>
                                                                                                <canvas id={'canvas_' + getSelectedDocId + '_' + nm.name + '_' + lb.name} hidden={true} ></canvas>
                                                                                            </div>

                                                                                        </div>
                                                                                        <div class='row'>
                                                                                            <div class='container'>
                                                                                                <div class='row'>
                                                                                                    <div class='col'><img title='Take Photo' onClick={takePicture} id={'take_' + getSelectedDocId + '_' + nm.name + '_' + lb.name} class='photoIcons' src={cameraicon}></img></div>
                                                                                                    <div class='col'><input type='file' id={'file_' + getSelectedDocId + '_' + nm.name + '_' + lb.name} style={{ display: 'none' }} onChange={handleChange} />
                                                                                                        <label htmlFor={'file_' + getSelectedDocId + '_' + nm.name + '_' + lb.name}>
                                                                                                            <img title='Upload Photo' class='photoIcons' id={'photo_' + getSelectedDocId + '_' + nm.name + '_' + lb.name} src={uploadicon}></img>
                                                                                                        </label></div>
                                                                                                    <div class='col'><img title='Clear' onClick={clearImage} id={'clearphoto_' + getSelectedDocId + '_' + nm.name + '_' + lb.name} class='photoIcons' src={clearicon}></img></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>


                                                                                </div>

                                                                            </div>
                                                                            : ''
                                                                    )
                                                                    )}
                                                                </div>
                                                                <div class='row'>
                                                                    {nm.labels?.map(lb =>

                                                                    (
                                                                        lb.enrollment_flag != undefined && lb.enrollment_flag == true && lb.control_type != 'photo' ?
                                                                            <div class={lb.name?.toUpperCase() == 'objectIssuerJson'.toUpperCase() ? 'col' : 'col-4'}>

                                                                                <div class="form-group  mt-3">
                                                                                    <label class='formText'>{lb.local_language_name == undefined || lb.local_language_name == '' ? lb.name
                                                                                        : lb.name + ' / ' + lb.local_language_name
                                                                                    }</label>
                                                                                    {

                                                                                        (lb.control_type.toUpperCase() == 'custom'.toUpperCase() && lb.name.toUpperCase() == 'driving_privileges'.toUpperCase()) ?
                                                                                            <DrivingPrivileges></DrivingPrivileges>
                                                                                            :
                                                                                            <>
                                                                                                {(lb.control_type.toUpperCase() == 'custom'.toUpperCase() && lb.name.toUpperCase() == 'objectIssuerJson'.toUpperCase()) ?
                                                                                                    <ObjectIssuerJson lb={lb} nm={nm}></ObjectIssuerJson>
                                                                                                    : (lb.control_type.toUpperCase() == 'custom'.toUpperCase() && lb.name.toUpperCase() == 'sex'.toUpperCase()) ?
                                                                                                        <GenderCategory></GenderCategory>
                                                                                                        : (lb.control_type.toUpperCase() == 'boolean'.toUpperCase()) ?
                                                                                                            <BooleanControl lb={lb} nm={nm}></BooleanControl>
                                                                                                            :
                                                                                                            <input type={lb.control_type ?? "text"} id={getSelectedDocId + '_' + nm.name + '_' + lb.name}
                                                                                                                defaultValue={lb.default_value}
                                                                                                                class="textField formText" aria-label={lb.name} />
                                                                                                }
                                                                                            </>


                                                                                    }
                                                                                </div>

                                                                            </div>
                                                                            : ''
                                                                    )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div></div>
                                                </div>

                                            ))

                                        }

                                    </>

                                ))

                            }

                        </div>
                    </div>

                </div>
                <div>
                    <div class="col-md-6">


                        {

                            (getSaveMode == 'Save' || getTemplateMode == 'New') ?
                                <button type="button" class="secondaryButton mt-4 ms-1" onClick={CancelTemplateMode} aria-label="submit">Cancel</button> : ''

                        }

                        {

                            (getSaveMode == 'Save') ?
                                <button type="button" class="primaryButton mt-4 ms-1" onClick={postconfigurations} aria-label="submit">{isUpdateMode ? 'Update' : 'Submit'}</button>
                                : ''

                        }



                    </div>
                </div>
                <div class='row'>
                    <div class='col'>
                        <QrCodePopUp></QrCodePopUp>
                    </div>
                </div>
            </div>
        </Layout>
    );

    function CancelTemplateMode() {
        if (isUpdateMode) {
            navigate('/documents/status')
        }
        setSelectedDocumentData([]);
        setTemplateMode('Exist');
        setSaveMode('');
        document.getElementById('ddlTemplates').value = '0';
        setSelectedDocId('0')
        setSelectedTemplateId('0')
        issuerReference = '';
        objectPix1HexModified = '';

        document.getElementById('tbIssuerReference').value = issuerReference;

    }

    async function postconfigurations() {
        document.getElementById('loadingProgressG').style.display = 'block';
        try {

            let validationPassed = true;
            issuerReference = isUpdateMode ? id : issuerReference;
            if (issuerReference == undefined || issuerReference.trim().length == 0) {
                validationPassed = false;
                toast.error('All fields are mandatory. Please fill Issuer Reference.');
                document.getElementById('loadingProgressG').style.display = 'none';
                return;
            }

            let documentTemplate = {
                documentData: {
                    docType: getSelectedDocumentData[0].documentData.docType,
                    namespaces: []
                },
                documentNumber: ''
            }

            getSelectedDocumentData?.map(ds => {

                ds.documentData.namespaces?.map(nm => {

                    let namespace = {
                        name: nm.name,
                        labels: []
                    }

                    nm.labels?.filter(fi => fi.enrollment_flag == true).map(lb => {

                        let user_input = '';

                        if (lb.control_type == 'photo') {
                            let photo = document.getElementById('canvas_' + getSelectedDocId + '_' + nm.name + '_' + lb.name)
                            let encodedPhoto = photo.toDataURL('image/jpeg', 1.0)

                            user_input = Buffer.from(base64ToHex(encodedPhoto.replace(/^data:image.+;base64,/, '')), 'hex');


                        } else if (lb.control_type == 'date') {
                            let user_date_value = document.getElementById(getSelectedDocId + '_' + nm.name + '_' + lb.name).value;
                            if (user_date_value == undefined || user_date_value.length == 0) {
                                validationPassed = false;
                                toast.error('All fields are mandatory. Please fill ' + lb.name + '.');
                                return;
                            }

                            user_input = new cbor.Tagged(Number(lb.cbor_tag), user_date_value);
                        } else if (lb.control_type == 'text') {
                            user_input = document.getElementById(getSelectedDocId + '_' + nm.name + '_' + lb.name).value;
                            if (user_input == undefined || user_input.trim().length == 0) {
                                validationPassed = false;
                                toast.error('All fields are mandatory. Please fill ' + lb.name + '.');
                                return;
                            }
                            user_input = user_input.trim();
                        } else if (lb.control_type == 'custom') {

                            if (lb.name.toUpperCase() == 'driving_privileges'.toUpperCase()) {
                                let drivingPrivilegesTagCode = 1004;
                                let categoryA = document.getElementById('chkDPA').checked;
                                let categoryB = document.getElementById('chkDPB').checked;
                                let categoryC = document.getElementById('chkDPC').checked;
                                let categoryD = document.getElementById('chkDPD').checked;

                                var drivingPrivileges = [];
                                let todayDate = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000);
                                let fromDateFormatted = new Date(todayDate).toISOString().split("T")[0];
                                let toDateFormatted = new Date(todayDate.getFullYear() + 1, todayDate.getMonth(), todayDate.getDate())
                                    .toISOString().split("T")[0];;

                                if (categoryA == true) {
                                    let drivingPrivilege = new Map();
                                    drivingPrivilege.set("vehicle_category_code", "A");
                                    drivingPrivilege.set("issue_date", new cbor.Tagged(drivingPrivilegesTagCode, fromDateFormatted));
                                    drivingPrivilege.set("expiry_date", new cbor.Tagged(drivingPrivilegesTagCode, toDateFormatted));
                                    drivingPrivileges.push(drivingPrivilege);
                                }
                                if (categoryB == true) {
                                    let drivingPrivilege = new Map();
                                    drivingPrivilege.set("vehicle_category_code", "B");
                                    drivingPrivilege.set("issue_date", new cbor.Tagged(drivingPrivilegesTagCode, fromDateFormatted));
                                    drivingPrivilege.set("expiry_date", new cbor.Tagged(drivingPrivilegesTagCode, toDateFormatted));
                                    drivingPrivileges.push(drivingPrivilege);
                                }
                                if (categoryC == true) {
                                    let drivingPrivilege = new Map();
                                    drivingPrivilege.set("vehicle_category_code", "C");
                                    drivingPrivilege.set("issue_date", new cbor.Tagged(drivingPrivilegesTagCode, fromDateFormatted));
                                    drivingPrivilege.set("expiry_date", new cbor.Tagged(drivingPrivilegesTagCode, toDateFormatted));
                                    drivingPrivileges.push(drivingPrivilege);
                                }
                                if (categoryD == true) {
                                    let drivingPrivilege = new Map();
                                    drivingPrivilege.set("vehicle_category_code", "D");
                                    drivingPrivilege.set("issue_date", new cbor.Tagged(drivingPrivilegesTagCode, fromDateFormatted));
                                    drivingPrivilege.set("expiry_date", new cbor.Tagged(drivingPrivilegesTagCode, toDateFormatted));
                                    drivingPrivileges.push(drivingPrivilege);
                                }
                                user_input = drivingPrivileges;

                                if (user_input == undefined || user_input.length == 0) {
                                    validationPassed = false;
                                    toast.error('All fields are mandatory. Please select ' + lb.name + '.');
                                    return;
                                }

                            }

                            if (lb.name.toUpperCase() == 'objectIssuerJson'.toUpperCase()) {
                                user_input = document.getElementById(getSelectedDocId + '_' + nm.name + '_' + lb.name).value;
                                user_input = JSON.parse(user_input);
                                user_input.objectIssuerJSON.objectText1 =
                                    document.getElementById('tbobjectText1').value;
                                user_input.objectIssuerJSON.objectText2 =
                                    document.getElementById('tbobjectText2').value;
                                user_input.objectIssuerJSON.objectText3 =
                                    document.getElementById('tbobjectText3').value;


                                if ((user_input.objectIssuerJSON.objectText1 == undefined || user_input.objectIssuerJSON.objectText1.length == 0) ||
                                    (user_input.objectIssuerJSON.objectText2 == undefined || user_input.objectIssuerJSON.objectText2.length == 0) ||
                                    (user_input.objectIssuerJSON.objectText3 == undefined || user_input.objectIssuerJSON.objectText3.length == 0)) {

                                    validationPassed = false;
                                    toast.error('All fields are mandatory. Please fill objectText(1,2,3) from ' + lb.name + '.');
                                    return;
                                }

                                user_input.objectIssuerJSON.objectText1 = user_input.objectIssuerJSON.objectText1.trim();
                                user_input.objectIssuerJSON.objectText2 = user_input.objectIssuerJSON.objectText2.trim();
                                user_input.objectIssuerJSON.objectText3 = user_input.objectIssuerJSON.objectText3.trim();
                                if (objectPix1HexModified != '') {
                                    user_input.objectIssuerJSON.objectPix1
                                        = objectPix1HexModified;

                                }

                                user_input = JSON.stringify(user_input);

                            }

                            if (lb.name.toUpperCase() == 'sex'.toUpperCase()) {

                                let genderInput = document.getElementById('ddlGender').value;
                                if (genderInput == '') {
                                    validationPassed = false;
                                    toast.error('All fields are mandatory. Please select gender type.');
                                    return;
                                } else {
                                    user_input = parseInt(genderInput);
                                }

                            }
                        } else if (lb.control_type.toUpperCase() == 'boolean'.toUpperCase()) {
                            let booleanSelected = document.getElementById('boolean_' + getSelectedDocId + '_' + nm.name + '_' + lb.name).value;

                            if (booleanSelected == '') {
                                validationPassed = false;
                                toast.error('All fields are mandatory. Please select ' + lb.name + '.');
                                return;
                            } else {
                                user_input = booleanSelected == 'TRUE' ? true : false;
                            }


                        } else if (lb.control_type == 'number') {
                            let userInputData = document.getElementById(getSelectedDocId + '_' + nm.name + '_' + lb.name).value;
                            if (userInputData == undefined || userInputData.length == 0) {
                                validationPassed = false;
                                toast.error('All fields are mandatory. Please fill ' + lb.name + '.');
                                return;
                            }

                            user_input = parseInt(userInputData);
                        } else {
                            user_input = '';
                        }

                        let label = {
                            name: lb.name,
                            input_value: user_input
                        }
                        namespace.labels.push(label);



                        if (label.name.toUpperCase() == 'Document_number'.toUpperCase()) {
                            documentTemplate.documentNumber = label.input_value;
                        }

                    });

                    documentTemplate.documentData.namespaces.push(namespace);
                });

            });

            if (validationPassed) {
                let documentData = new Map();
                documentData.set("docType", documentTemplate.documentData.docType);

                let nameSpace = new Map();

                documentTemplate.documentData.namespaces.forEach(nmi => {

                    let dataItems = [];
                    nmi.labels.forEach(lbi => {

                        if (lbi.name.toUpperCase() == 'objectIssuerJson'.toUpperCase()) {
                            lbi.input_value = lbi.input_value.replace(/<<DYNAMIC_OBJECT_ID>>/g,
                                issuerReference);
                        }

                        if (lbi.name.toUpperCase() == 'objectDataJson'.toUpperCase()) {
                            lbi.input_value = lbi.input_value.replace(/<<DYNAMIC_OBJECT_ID>>/g,
                                issuerReference);
                        }

                        let dataItem = new Map();
                        dataItem.set("name", lbi.name);
                        dataItem.set("value", lbi.input_value);
                        dataItem.set("accessControlProfiles", [0]);
                        dataItems.push(dataItem);

                    });

                    nameSpace.set(nmi.name, dataItems);
                });

                documentData.set("nameSpaces", nameSpace);
                let accessControlProfiles = [];
                let accessControlProfile = new Map();
                accessControlProfile.set("id", 0);
                accessControlProfile.set("userAuthenticationRequired", false);
                accessControlProfile.set("timeoutMillis", 0);
                accessControlProfiles.push(accessControlProfile);
                documentData.set("accessControlProfiles", accessControlProfiles);
                var documentDataEncoded = new Buffer(cbor.encode(documentData));

                let userstateparametervalue = sessionStorage.getItem('userstate');
                let userstateurlvalue = "";

                if (userstateparametervalue!= "" && userstateparametervalue != null && userstateparametervalue != undefined) {
                    userstateurlvalue = "/" + userstateparametervalue;
                    setuserstatevalue(true);
                }

                const response = await axios.request({
                    method: isUpdateMode ? 'PUT' : 'POST',
                    url: config.operatorportal.apibaseurl + 'document/configurations/issue/' + issuerReference,
                    headers: { "content-type": "application/cbor", Authorization: `Bearer ${config.operatorportal.documentapijwttoken}` },
                    responseType: 'arraybuffer',
                    responseEncoding: 'binary',
                    data: documentDataEncoded
                });
                let message = '';

                if (response.status == 201 || response.status == 200) {
                    if (isUpdateMode) {
                        toast('PUT request succeded.');
                        navigate('/documents/status');
                    } else { 
                        let qrData = config.operatorportal.deeplinkurl + Base64.fromUint8Array(new Uint8Array(response.data), true);
                        setValue(qrData);
                        setSmShow(true);
                        CancelTemplateMode();
                    }
                }
                else {

                    if (response.headers.get("content-type").includes('json')) {
                        let enrollmentStatus = await response.json();
                        message = response.status + ' ' + enrollmentStatus.message;
                    } else {
                        message = response.status + ' ' + response.statusText;
                    }
                    toast.error(message);

                }
            }

            document.getElementById('loadingProgressG').style.display = 'none';

        } catch (error) {
            if (error.response?.data != undefined) {
                let documentStatusData = cbor.decode(new Buffer(error.response.data));
                toast.error(documentStatusData.message);
                document.getElementById('loadingProgressG').style.display = 'none';
                return;
            }
            document.getElementById('loadingProgressG').style.display = 'none';
            toast.error(error.message)
        }

    }


    async function populateSelectedTemplateDetails() {

        try {
            issuerReference = isUpdateMode ? id : '';
            document.getElementById('tbIssuerReference').value = issuerReference;
            document.getElementById('loadingProgressG').style.display = 'block';
            let selectedTemplateId =
                document.getElementById('ddlTemplates').value;
            setSelectedTemplateId(selectedTemplateId);

            if (selectedTemplateId == '0') {
                setdocuments([]);
                CancelTemplateMode();
                document.getElementById('loadingProgressG').style.display = 'none';
                return;
            }



            const response = await axios.request({
                method: 'GET',
                url: config.operatorportal.apibaseurl + 'document/configurations/templates?id=' + selectedTemplateId,
                headers: { "content-type": "application/cbor", Authorization: `Bearer ${sessionStorage.getItem('access_token')}` },
                responseType: 'arraybuffer',
                responseEncoding: 'binary',
            });


            if (response.status == 200) {

                let templateDecoded = cbor.decode(new Buffer(response.data));
                setSelectedDocumentData([]);
                let selectedDoc = [];
                selectedDoc.push(templateDecoded)
                setSelectedDocumentData(selectedDoc);
                setSaveMode('Save');


            } else {
                setSelectedDocumentData([]);
                toast.error('Failed.');
            }

            document.getElementById('loadingProgressG').style.display = 'none';

        } catch (error) {
            document.getElementById('loadingProgressG').style.display = 'none';
            toast.error(error.message);
        }




    }


    function QrCodePopUp() {
        return (
            <>
                <Modal
                    size="lg"
                    show={smShow}
                    onHide={() => setSmShow(false)}
                    aria-labelledby="example-modal-sizes-title-lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="example-modal-sizes-title-lg">
                            QR Code
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class='row'>
                            <center>
                                <QRCode
                                    value={value}
                                    bgColor={back}
                                    fgColor={fore}
                                    size={size === '' ? 0 : size}
                                />
                            </center>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        );
    }


    function DrivingPrivileges() {
        return (
            <>
                <div class='row'>
                    <div class='col-6'>
                        <div class="form-check form-switch">
                            <label class='formText'>A-Motorcycle
                                <input class="form-check-input" type="checkbox" id='chkDPA' name='chkDPA'
                                    value="yes" /></label>
                        </div>

                        <div class="form-check form-switch">
                            <label class='formText'>B-Car
                                <input class="form-check-input" type="checkbox" id='chkDPB' name='chkDPB'
                                    value="yes" /></label>
                        </div>


                    </div>
                    <div class='col-6'>
                        <div class="form-check form-switch">
                            <label class='formText'>C-Truck
                                <input class="form-check-input" type="checkbox" id='chkDPC' name='chkDPC'
                                    value="yes" /></label>
                        </div>

                        <div class="form-check form-switch">
                            <label class='formText'>D-Bus
                                <input class="form-check-input" type="checkbox" id='chkDPD' name='chkDPD'
                                    value="yes" /></label>
                        </div>

                    </div>

                </div>
            </>

        )
    }


    function ObjectIssuerJson(issuerInfo) {

        let issuerJSONDefault = JSON.parse(issuerInfo.lb.default_value);

        objectPix1HexModified = '';

        var objectPix1Original = Buffer.from(issuerJSONDefault.objectIssuerJSON.objectPix1, 'hex').toString('base64');



        return <>
            <div class='row'>
                <div class='col'>
                    <input type={issuerInfo.lb.control_type ?? "text"} id={getSelectedDocId + '_' + issuerInfo.nm.name + '_' + issuerInfo.lb.name} defaultValue={issuerInfo.lb.default_value} placeholder='Default Value' class="textField formText" aria-label={issuerInfo.lb.name} />
                </div>
            </div>
            <div class='row'>
                <div class="mt-3 col-4">
                    <label class='formText'>objectText1</label>
                    <input class="textField" type="text" defaultValue={issuerJSONDefault.objectIssuerJSON.objectText1} id='tbobjectText1' name='tbobjectText1'
                    />
                </div>

                <div class="mt-3 col-4">
                    <label class='formText'>objectText2</label>
                    <input class="textField" type="text" defaultValue={issuerJSONDefault.objectIssuerJSON.objectText2} id='tbobjectText2' name='tbobjectText2'
                    />
                </div>

                <div class="mt-3 col-4">
                    <label class='formText'>objectText3</label>
                    <input class="textField" type="text" defaultValue={issuerJSONDefault.objectIssuerJSON.objectText3} id='tbobjectText3' name='tbobjectText3'
                    />
                </div>
            </div>
            <div class='row'>
                <div class='mt-3 col-4'>
                    <div class='row'>
                        <label class='formText'>objectPix1</label>
                    </div>
                    <div class='row'>
                        <img id='image_objPicture1' src={'data:image/jpeg;base64,' + objectPix1Original} />
                        <div class='col'><input type='file' id={'file_objectPix1'} style={{ display: 'none' }} onChange={handleobjectPix1Change} />
                            <label htmlFor={'file_objectPix1'}>
                                <img title='Upload' class='photoIcons' id={'photo_objectPix1'} src={uploadicon}></img>
                            </label></div>

                    </div>


                </div>

            </div>

        </>
    }

    function base64ToHex(str) {
        const raw = window.atob(str);
        let result = '';
        for (let i = 0; i < raw.length; i++) {
            const hex = raw.charCodeAt(i).toString(16);
            result += (hex.length === 2 ? hex : '0' + hex);
        }
        return result.toUpperCase();
    }

    function GenderCategory() {
        return (
            <>
                <div class='row'>
                    <div class="col-4 w-100">
                        <select class="textField" id='ddlGender'>
                            <option value=''>Select Gender</option>
                            <option value='0'>Not known</option>
                            <option value='1'>Male</option>
                            <option value='2'>Female</option>
                            <option value='9'>Not applicable</option>
                        </select>
                    </div>
                </div>
            </>

        )
    }


    function BooleanControl(issuerInfo) {
        return (
            <>
                <div class='row'>
                    <div class="col-4 w-100">
                        <select class="textField" id={'boolean_' + getSelectedDocId + '_' + issuerInfo.nm.name + '_' + issuerInfo.lb.name}>
                            <option value=''>Select {issuerInfo.lb.name}</option>
                            <option value='TRUE'>TRUE</option>
                            <option value='FALSE'>FALSE</option>
                        </select>
                    </div>
                </div>
            </>

        )
    }


    function handleobjectPix1Change(e) {

        if (e.target.files && e.target.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                document.getElementById('image_objPicture1').src = e.target.result;
                objectPix1HexModified =
                    base64ToHex(e.target.result.replace(/^data:image.+;base64,/, ''))
            };
            reader.readAsDataURL(e.target.files[0]);
        }


    }

}


